import React, { useMemo } from "react";
import { Download, LoaderCircle } from "lucide-react";
import QRCode from "qrcode";

export function BullseyeBulletinPrintControls({ sections, selectedSection, onSectionChange, onPrint, disabled, busy, error, children }) {
  return <div className="bullseye-bulletin-export">
    <p className="match-download-summary">{selectedSection === "all" ? "All result sections" : sections.find(section => section.key === selectedSection)?.title} · Published award groupings · PDF</p>
    <label className="leaderboard-field" htmlFor="bullseye-pdf-section">
      <span>PDF section</span>
      <select id="bullseye-pdf-section" className="match-sort" value={selectedSection}
        disabled={disabled || busy} onChange={event => onSectionChange(event.target.value)}>
        <option value="all">All results</option>
        {sections.map(section => <option key={section.key} value={section.key}>{section.title}</option>)}
      </select>
    </label>
    <button type="button" className="registration-auth-secondary leaderboard-inline-link bullseye-print-bulletin-button"
      onClick={onPrint} disabled={disabled || busy} aria-busy={busy || undefined}>
      {busy ? <LoaderCircle size={17} aria-hidden="true" /> : <Download size={17} aria-hidden="true" />}
      {busy ? "Preparing PDF..." : "Download Bulletin PDF"}
    </button>
    {children}
    {error && <p className="bullseye-bulletin-export-error" role="alert">{error}</p>}
  </div>;
}

export function BullseyeBulletinPrintHeader({ matchId, name, date, location }) {
  // Match the Live Standings QR destination, never localhost or viewer filters.
  const url = `https://www.armorysync.com/matches/bullseye/${encodeURIComponent(matchId)}`;
  const qr = useMemo(() => {
    const { modules } = QRCode.create(url, { errorCorrectionLevel: "M" });
    const path = [];
    for (let row = 0; row < modules.size; row += 1) {
      for (let column = 0; column < modules.size; column += 1) {
        if (modules.get(row, column)) path.push(`M${column + 4} ${row + 4}h1v1h-1z`);
      }
    }
    return { size: modules.size + 8, path: path.join("") };
  }, [url]);

  return <section className="bullseye-print-bulletin-header" aria-label="Printable bulletin header">
    <div className="bullseye-print-heading">
      <div>TOURNAMENT RESULTS BULLETIN</div>
      <strong>{name}</strong>
      <span>{date}{location ? ` - ${location}` : ""}</span>
    </div>
    <a className="bullseye-print-qr" href={url} aria-label="Open live match results">
      <svg role="img" aria-label="Live match results QR code" viewBox={`0 0 ${qr.size} ${qr.size}`} shapeRendering="crispEdges">
        <rect width={qr.size} height={qr.size} fill="#fff" />
        <path d={qr.path} fill="#000" />
      </svg>
      <span>Live results</span>
    </a>
  </section>;
}
